import React, { FC } from 'react'
import { Grid } from '@mui/material'
import { BankAccounts } from './BankAccounts'
import { Wallets } from './Wallets'

export const ClientAccounts: FC = () => (
  <Grid container display="flex" flexDirection="row">
    <Grid item xs={12} md={6} pr={1.5}>
      <BankAccounts />
    </Grid>
    <Grid item xs={12} md={6} pl={1.5}>
      <Wallets />
    </Grid>
  </Grid>
)
